import React from "react"
import {ConventionalLids} from "./ConventionalLids";
import {SubFloorLid} from "./SubFloorLid";
import {Plan} from "types";

interface LidGroundViewProps {
    plan: Plan,
    scale: number,
}

export const LidGroundView: React.FC<LidGroundViewProps> = ({plan, scale}) => {
    return plan.lid.type === 'A15' || plan.lid.type === 'B125' || plan.lid.type === 'D400' || plan.lid.type === 'E600'
        ? <ConventionalLids plan={plan} scale={scale}/>
        : plan.lid.type === 'subfloor'
            ? <SubFloorLid plan={plan} scale={scale}/>
            : null
}
